/**
 * Handles beigeweek promo URL parameter
 * Deletes Shoplift cookies and reloads the page
 */
export function initBeigeweekPromo(): void {
  const urlParams = new URLSearchParams(window.location.search);
  const promoParam = urlParams.get('promo');

  // Check if we've already processed this in this session
  const alreadyProcessed = sessionStorage.getItem('beigeweek_promo_processed');

  if (promoParam === 'beigeweek' && !alreadyProcessed) {
    
    // Mark as processed to prevent infinite loop
    sessionStorage.setItem('beigeweek_promo_processed', 'true');
    
    // Delete Shoplift cookies
    const cookiesToDelete = ['Shoplift_Analytics', 'Shoplift_Essential', 'Shoplift_Session'];

    for (const cookieName of cookiesToDelete) {
      // Delete cookie by setting it to expire in the past
      // Also try with different path and domain combinations
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname};`;
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${window.location.hostname};`;
    }

    // Reload page with the promo parameter still in the URL
    window.location.reload();
  } else if (promoParam === 'beigeweek' && alreadyProcessed) {
  } else {
  }
}

